module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view--loans"
  }, [_c('pane-header', {
    attrs: {
      "tools": _vm.tools,
      "hasBackButton": true,
      "title": ("Fees/fines - Patron: " + (_vm.user.lastname) + ", " + (_vm.user.firstname) + " (" + (_vm.user.patron_group) + ")")
    }
  }), _vm._v(" "), (false) ? _c('pre', [_vm._v("        " + _vm._s(JSON.stringify(_vm.currentView, null, 4)) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('ui-padding', [_c('div', {
    staticClass: "loan-details__buttons"
  }, [_c('ui-search-field', {
    staticClass: "loan-details__search-field",
    attrs: {
      "tools": _vm.tools
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "loan-details__results"
  }, [_vm._v("12 records found")]), _vm._v(" "), _c('div', {
    staticClass: "loan-details__buttons__right-align"
  }, [_c('ui-button', {
    attrs: {
      "title": "Charge manual fee/fine"
    }
  }), _vm._v(" "), _c('ui-button', {
    attrs: {
      "title": "Pay"
    }
  }), _vm._v(" "), _c('ui-button', {
    attrs: {
      "title": "Waive"
    }
  }), _vm._v(" "), _c('ui-button', {
    attrs: {
      "title": "Refund"
    }
  }), _vm._v(" "), _c('ui-button', {
    attrs: {
      "title": "Transfer"
    }
  })], 1)], 1)]), _vm._v(" "), _c('ui-padding', {
    staticClass: "overflow-auto"
  }, [_c('ui-data-list', {
    staticClass: "col-min-120",
    attrs: {
      "hasCheckBox": true,
      "preset": "fee",
      "type": "results",
      "tools": _vm.tools,
      "maxItems": 12,
      "minItems": 3,
      "cache": true,
      "includeInList": {
        user: _vm.user
      },
      "dropdown": _vm.dropdownOptions
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55f52d70","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/FeesView.vue
// module id = 446
// module chunks = 1